// Don't edit this file. it only exists so expo can build the web version because react-native-track-player is not available for the web.
export default {
  async setupTP() {},
};
